export class FeatureSettings {
    featureID: string;
    enabled: boolean = false;
    allowedDurations: number[];
    allowedChannels: string[];
    allowedRoles: string[];
  }